function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 1,
  fill: "#FFE8D0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.402 16H3.598c-.33 0-.598.224-.598.5s.268.5.598.5h17.804c.33 0 .598-.224.598-.5s-.267-.5-.598-.5zM22 19.5c0-.276-.267-.5-.598-.5H3.598c-.33 0-.598.224-.598.5s.268.5.598.5h17.804c.33 0 .598-.224.598-.5z",
  fill: "#F4AB8A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.017 22.91H.982C.44 22.91 0 22.501 0 22v1.09c0 .503.44.91.982.91h22.035c.543 0 .983-.407.983-.91V22c0 .502-.44.91-.983.91z",
  fill: "#FAC68F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 8.5a5.5 5.5 0 11-7.348-5.18L11.5 8.5H17z",
  fill: "#C57C5B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 7.5a5.5 5.5 0 00-7.315-5.192L12.5 7.5H18z",
  fill: "#F4AB8A"
});

function SvgReportsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgReportsIcon;